import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import moment from "moment";
import AddTKCSOrder from "./AddTKCSOrder";
import UpdateTKCSOrder from "./UpdateTKCSOrder";
import { toast } from "react-toastify";
import Pagination from "../../Common/Pagination/Pagination";
import { sweetAlert } from "../../Common/Utills/Utills";
import _ from "lodash";
import { minDate } from "../../Constants/Constants";
import * as XLSX from "xlsx";
const TKCSOrderDetails = () => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rowData, setRowData] = useState([]);
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedCompanyId ? selectedCompanyId : "",
    po_date: "",
    party_name: "",
  });
  const [rowId, setRowId] = useState("");

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const exportToExcel = (rowData) => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert rowData to a worksheet
    const ws = XLSX.utils.json_to_sheet(
      rowData.map((item, index) => ({
        "S.NO": (currentPage - 1) * pageSize + index + 1,
        "Company Name":
          item.companyDetails.company_name +
          ", " +
          item?.companyDetails?.location,
        "Party Name": item?.party_name,
        "Po.No": item?.po_number,
        "Product Size": item?.product_quantity_details
          ?.map((detail) => detail.size)
          .join(", "),
        "Po Qty": item?.product_quantity_details
          ?.map((detail) => detail.po_qty)
          .join(", "),
        "Po Date": item.po_date,
        "Payment Term": item.payment_term,
      }))
    );

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "TKCS Order Details");

    // Export the workbook
    XLSX.writeFile(wb, "TKCS_Order_Details.xlsx");
  };

  const formRef = useRef(null);
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setCurrentPage(1); // Reset to the first page when page size changes
  };
  const handleRefreshClick = () => {
    getData();
    setSelectedCompanyId("");
    setfilterCriteria({ company_id: "", po_date: "" });
  };

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...filterCriteria,
        [name]: value,
      };
    });
  };

  const nonEmptyFilterCriteria = Object.fromEntries(
    Object.entries(filterCriteria).filter(
      ([key, value]) => value !== null && value !== undefined && value !== ""
    )
  );
  const options = {
    whereFilters: nonEmptyFilterCriteria,
    skip: currentPage,
    take: pageSize,
  };
  const getData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/private-order/all-private-orders/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(
        result.data.map((item, index) => {
          return {
            ...item,
            po_date: moment(item.po_date).format("YYYY-MM-DD"),
          };
        })
      );
    } else {
      setRowData([]);
    }
  };

  let check = true;

  useEffect(() => {
    if (check) {
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
    check = false;
  }, [currentPage, pageSize, filterCriteria]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  const addDataToModal = (id) => {
    setRowId(id);
  };

  const deleteOrderData = async (order_id) => {
    const message = "Do you want to delete this TKCS order details!";
    const result = await sweetAlert(message);
    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL + `/api/private-order/private-order/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (e) => {
    const companyId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            TKCS Order Details &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add TKCS Order
              </button>
              <button
                className="btn btn-outline-excel  ml-2"
                onClick={() => exportToExcel(rowData)}
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-excel" />
                </span>
                Export to Excel
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            ></div>
          </div>
          <div className="search mb-3">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control form-control-lg"
                    onChange={handleCompanyChange}
                    value={selectedCompanyId}
                  >
                    <option value="">Select Company (All)</option>
                    {company?.map((item, id) => {
                      return (
                        <React.Fragment key={id}>
                          <option
                            value={item.id}
                            key={id}
                          >{`${item.company_name}, ${item.location}`}</option>
                        </React.Fragment>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Search by party name"
                  onChange={(e) =>
                    handleFilterChange("party_name", e.target.value)
                  }
                  value={filterCriteria.party_name}
                  min={minDate}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control form-control-lg"
                  placeholder="Search by Po Date"
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) =>
                    handleFilterChange("po_date", e.target.value)
                  }
                  value={filterCriteria.po_date}
                  min={minDate}
                />
              </div>
            </div>
          </div>
          <div className="private-table-container">
            <div
              className="table-responsive table-bordered govt-table"
              style={{ border: "0.05px solid lightGray", width: "auto" }}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th rowSpan="2">S.NO</th>
                    <th rowSpan="2">Company</th>
                    <th rowSpan="2">Party Name</th>
                    <th rowSpan="2">Po.No</th>
                    <th
                      colSpan="2"
                      style={{
                        textAlign: "center",
                        verticalAlign: "top",
                      }}
                    >
                      Order Details
                    </th>{" "}
                    <th rowSpan="2">Po Date</th>
                    <th rowSpan="2">Payment Term</th>
                    <th rowSpan="2">Actions</th>
                  </tr>
                  <tr>
                    <th>Size</th>
                    <th>Po Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {rowData && rowData.length > 0 ? (
                    rowData &&
                    rowData?.length > 0 &&
                    rowData?.map((item, index) => {
                      return (
                        <tr key={index}>
                          {/* <td>{index + 1}</td> */}
                          <td>{(currentPage - 1) * pageSize + index + 1}</td>
                          <td>
                            {item.companyDetails.company_name +
                              ", " +
                              item?.companyDetails?.location}
                          </td>
                          <td>{item.party_name}</td>
                          <td>{item.po_number}</td>
                          <td style={{ lineHeight: "30px" }}>
                            {" "}
                            {item?.product_quantity_details?.map(
                              (detail, idx) => (
                                <div key={idx}>
                                  <div>{detail.size}</div>
                                </div>
                              )
                            )}
                          </td>
                          <td style={{ lineHeight: "30px" }}>
                            {" "}
                            {item?.product_quantity_details?.map(
                              (detail, idx) => (
                                <div key={idx}>
                                  <div>{detail.po_qty}</div>
                                </div>
                              )
                            )}
                          </td>
                          <td>{item.po_date}</td>
                          <td>{item.payment_term ? item.payment_term : "-"}</td>
                          <td style={{ padding: "10px" }}>
                            <button
                              className="btn btn-outline-secondary btn-sm ml-2"
                              onClick={() => addDataToModal(item.id)}
                              data-toggle="modal"
                              data-target="#updateModal"
                            >
                              <i className="mdi mdi-note-edit-outline" />
                            </button>
                            <button
                              className="btn btn-outline-danger btn-sm ml-2"
                              onClick={() => deleteOrderData(item.id)}
                            >
                              <i className="mdi mdi-delete" />
                            </button>{" "}
                            <NavLink
                              className="btn btn-outline-info btn-sm ml-1"
                              to={"/view-TKCS-order-detials/" + item.id}
                            >
                              <i className="mdi mdi-eye-arrow-right-outline" />
                            </NavLink>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="9">
                        <div className="loading-container">
                          <p>No row to show</p>
                        </div>
                      </td>
                    </tr>
                  )}

                  {/* <tr>
                    <td>1</td>
                    <td>Ksum Industries, Rewa</td>
                    <td>RVNL</td>
                    <td>9.1M 280KG</td>
                    <td>RVNL/B/E/RDSS/MPPK/Pkg-10/Spot/PCC Poles</td>
                    <td>06.05.23</td>
                    <td>800</td>
                    <td>Satna</td>
                    <td>3275</td>
                    <td>40% Advance of the base of value</td>
                    <td>
                      {" "}
                      <NavLink
                        className="btn btn-outline-primary btn-sm"
                        to="/view-TKCS-order-detials"
                      >
                        <i className="mdi mdi-eye-arrow-right-outline" />
                      </NavLink>
                    </td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>
          <AddTKCSOrder getData={getData} formRef={formRef} />
          <UpdateTKCSOrder
            getData={getData}
            setRowId={setRowId}
            rowID={rowId}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default TKCSOrderDetails;
